export const COUNTRY_LABELS = {
  AU: 'Australia',
  CA: 'Canada',
  GB: 'United Kingdom',
  GI: 'Gibraltar',
  NZ: 'New Zealand',
  US: 'United States'
};

export const SETTINGS_TABS = [
  { id: 'subscription', label: 'Subscription', path: '/settings/subscription', showSave: false },
  { id: 'accounting-platform', label: 'Accounting platform', path: '/settings/accounting-platform', showSave: false },
  { id: 'jobtread', label: 'JobTread', path: '/settings/jobtread', showSave: true },
  { id: 'xero', label: 'Xero', path: '/settings/xero', showSave: true },
  { id: 'quickbooks', label: 'QuickBooks', path: '/settings/quickbooks', showSave: false },
  { id: 'auto-sync', label: 'Auto Sync', path: '/settings/auto-sync', showSave: false },
  { id: 'invoice-settings', label: 'Invoice Settings', path: '/settings/invoice-settings', showSave: true },
  { id: 'bill-sync', label: 'Bill Settings', path: '/settings/bill-sync', showSave: true },
  { id: 'approvals', label: 'Approvals', path: '/settings/approvals', showSave: false },
  { id: 'cost-reporting', label: 'Cost Reporting', path: '/settings/cost-reporting', showSave: true },
  { id: 'organisation', label: 'Organisation Roles', path: '/settings/organisation', showSave: false }
];

export function getInitialFormData() {
  return {
    jobtreadApiKey: '',
    jobtreadOrgId: '',
    xeroInvoiceCode: '',
    xeroExpenseCode: '',
    xeroUSTaxType: '',
    xeroGBTaxType: '',
    xeroCATaxType: '',
    country: 'AU',
    province: null,
    excludedCostCodes: '',
    accountingPlatform: 'xero'
  };
}

export function getInitialBillSettings() {
  return {
    jtBillNameField: '',
    xeroCategoryName: '',
    xeroCategoryID: '',
    enabled: false,
    billmodedefaultjob: false,
    xeroExpenseBankAccountID: '',
    xeroExpenseBankAccountName: '',
    xeroExpenseAutoPayment: true,
    xeroExpenseSyncMode: 'bill',
    skipAutoApprove: false,
    markDirectImportBillsAsPaid: false,
    requireDirectBillApproval: false,
    directBillDueTerms: { type: 'none', override: false },
    billsAndExpenses: false,
    multiCurrencyEnabled: false,
    tracking: [
      { slot: 1, enabled: false, jtField: '', xeroCategoryID: '', xeroCategoryName: '' },
      { slot: 2, enabled: false, jtField: '', xeroCategoryID: '', xeroCategoryName: '' }
    ]
  };
}

export function getInitialInvoiceTrackingSettings() {
  return {
    jtJobField: '',
    xeroCategoryName: '',
    xeroCategoryID: '',
    enabled: false,
    lineItemRoundingMode: 'preserve',
    syncAsDraft: false,
    tracking: [
      { slot: 1, enabled: false, jtField: '', xeroCategoryID: '', xeroCategoryName: '' },
      { slot: 2, enabled: false, jtField: '', xeroCategoryID: '', xeroCategoryName: '' }
    ]
  };
}
